import { IUnparsedContext } from "../interfaces/IAuditoinnitContext";
import FormTypeMapper from "./FormTypeMapper";
import CategoryMapper from "./CategoryMapper";
import PermissionMapper from "./PermissionMapper";
import { IInitialContextResult } from "../services/contextService";
import { PersonMapper } from "../../sg-hpr/models/IPerson";


export const ContextMapper = {
    apiToDomain: (api: Partial<IInitialContextResult>): IUnparsedContext => {
        return {
            formTypes: api.lomakkeet ? api.lomakkeet.map(FormTypeMapper.apiToDomain) : undefined,
            categories: api.kategoriat ? api.kategoriat.map(CategoryMapper.apiToDomain) : undefined,
            persons: api.henkilot ? api.henkilot.map(PersonMapper.apiToDomain) : undefined,
            categoryPermissions: api.oikeustasot ? PermissionMapper.permissionsToDomain(api.oikeustasot) : undefined,
        };
    },
};

